import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=20efc008&scoped=true&"
import script from "./produce.vue?vue&type=script&lang=ts&"
export * from "./produce.vue?vue&type=script&lang=ts&"
import style0 from "./produce.vue?vue&type=style&index=0&id=20efc008&lang=postcss&scoped=true&"
import style1 from "./produce.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efc008",
  null
  
)

export default component.exports